
function Order(obj) {

    this.id  = (obj.id || null);
    this.due_date = obj.due_date || null;
    this.name = obj.string || null
    this.category_name = obj.category_name || null
    this.category_id = obj.category_id || ""
    this.payment_method_id = obj.payment_method_id || null
    this.payment_method_name = obj.payment_method_name || null
    this.pay_date  = obj.pay_date || null
    this.account_name = obj.account_name || null
    this.account_id = obj.account_id || null
    this.value = obj.value || 0
    this.type = obj.type || null
    this.is_paid = obj.is_paid || null
    this.service_id = obj.service_id || null
    this.fornecedor_id = obj.fornecedor_id || null
    this.cliente_id = obj.cliente_id || null
    this.calendar_id = obj.calendar_id || null
    this.customer_name = obj.customer_name || null
    this.customer_id = obj.customer_id || null
    this.repeat_period = obj.repeat_period || ""

}

module.exports = Order;